import YoutubeEmbed from './Loader';

export default YoutubeEmbed;
